<div>
  <div
    class="flex-col items-center gap-1 fixed bottom-12 right-12 z-50"
    [ngClass]="{
      hidden: !isFloatingButtonVisible,
      flex: isFloatingButtonVisible,
    }"
  >
    <button
      [id]="id + '-floating-button'"
      class="flex items-center h-12 w-12 px-3 py-2 btn-primary-blue text-center cursor-pointer rounded-full"
      (click)="scrollToTop()"
    >
      <span class="material-symbols-rounded">{{ arrowUpward }}</span>
    </button>
    <label
      [for]="id + '-floating-button'"
      class="body-default-bold text-tertiary text-center"
      >Back to top</label
    >
  </div>

  <div #pageBottomButton class="flex flex-col items-center gap-1">
    <button
      [id]="id + '-page-bottom-button'"
      class="flex items-center h-12 w-12 px-3 py-2 btn-primary-blue text-center cursor-pointer rounded-full"
      (click)="scrollToTop()"
    >
      <span class="material-symbols-rounded">{{ arrowUpward }}</span>
    </button>
    <label
      [for]="id + '-page-bottom-button'"
      class="body-default-bold text-tertiary text-center"
      >Back to top</label
    >
  </div>
</div>
